const INITIAL_STATE = {
    lista: [],
    listaVeiculoTipo: []
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
		case 'DASHBOARD_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };
        
        case 'DASHBOARD_VEICULO_TIPO_SELECT_LISTADO':
            console.log(action.payload.data);
            
            return { ...state, listaVeiculoTipo: action.payload.data };

        default:
            return state;
    }
}
